import { FormButton } from "../../../components/_input/_button";
import { InputField } from "../../../components/_input/_input";
import BackHeading from "../../../components/backHeading";
import { useTranslation } from "react-i18next";
import PhoneDropDown from "../../../components/_input/_phoneDropDown";
import { FileInput } from "../../../components/_input/_fileInput";
import { useState } from "react";
function AddressInsert() {
    const languageDir = 'language-' + localStorage.getItem('i18nextLng');
    const { t: trans, i18n } = useTranslation(['mobileForm']);
    const [requestForm, setRequestForm] = useState({

    });

    return (
        <div className={`registration-insert-page container mb-32 nice-apply-theme `}>


            <div className="container  nice-apply-theme">

                <div className="my-40">

                    {/* <BackHeading title={' العنوان'} /> */}
                </div>

                <div className="flex flex-row nice-gap-5rem flex-nowrap">
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:first_name")}
                            value={requestForm.firstName}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='firstName'
                        />
                    </div>
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:surname")}
                            value={""}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='lastName'
                        />
                    </div>
                </div>

                <PhoneDropDown
                    mandotory={true}
                    placeholder={trans("mobileForm:mobile")}
                    errorLabel={""}
                    onChangeValue={(countryCode, phoneNumber) => {

                    }}
                />

                <div className="flex flex-row nice-gap-5rem flex-nowrap">
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:company")}
                            value={requestForm.firstName}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='grandFathorName'
                        />
                    </div>
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:street")}
                            value={""}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='lastName'
                        />
                    </div>
                </div>

                <div className="flex flex-row nice-gap-5rem flex-nowrap">
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:district")}
                            value={requestForm.firstName}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='grandFathorName'
                        />
                    </div>
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:postal_code")}
                            value={""}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='lastName'
                        />
                    </div>
                </div>
           
                <div className="flex flex-row nice-gap-5rem flex-nowrap">
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:city")}
                            value={requestForm.firstName}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='grandFathorName'
                        />
                    </div>
                    <div className="grow">
                        <InputField
                            placeholder={trans("mobileForm:country")}
                            value={""}
                            errorLabel={""}
                            onChangeValue={(e) => {

                            }}
                            name='lastName'
                        />
                    </div>
                </div>

                <FormButton name={trans("mobileForm:save")}
                    //  isLoading={isLoading} 
                    //  onClick={submitRequest}
                    style={{ background: "#9aa69d" }}

                />

            </div>
        </div>
    );
}

export default AddressInsert;
